// StyleSelector Layout Component

import React from 'react';
import { Dropdown, Box } from '@wix/design-system';
import { DEFAULT_STYLES } from '../../types';
import { CoreDomainSearchDataHooks, CoreDomainSearchModule } from '../../module/module';
import sharedStyles from '../SharedStyles.scss';
import clsx from 'clsx';
export const StyleSelector = _ref => {
  let selectedStyle = _ref.selectedStyle,
    availableStyles = _ref.availableStyles,
    onChange = _ref.onChange;
  const _CoreDomainSearchModu = CoreDomainSearchModule.internals.useTranslations(),
    t = _CoreDomainSearchModu.t;
  const handleStyleSelect = optionId => {
    onChange == null || onChange(optionId);
  };
  const options = (availableStyles == null ? void 0 : availableStyles.map(_ref2 => {
    let id = _ref2.id,
      name = _ref2.name;
    return {
      id,
      value: name
    };
  })) ?? DEFAULT_STYLES.map(_ref3 => {
    let id = _ref3.id,
      key = _ref3.key;
    return {
      id,
      value: t(key)
    };
  });
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: CoreDomainSearchDataHooks.styleSelector,
    flex: 1,
    minWidth: "75px"
  }, /*#__PURE__*/React.createElement(Dropdown, {
    placeholder: t('core_domain_search.domain_gate.style_header'),
    size: "small",
    className: clsx(sharedStyles.dropdownContainer, {
      [sharedStyles.selected]: selectedStyle
    }),
    options: options,
    selectedId: selectedStyle,
    onSelect: option => handleStyleSelect(option.id),
    popoverProps: {
      role: 'presentation',
      placement: 'bottom-start',
      appendTo: 'window',
      maxWidth: 'max-content',
      fixed: true,
      moveBy: {
        x: 0,
        y: 0
      }
    },
    dataHook: CoreDomainSearchDataHooks.styleDropdown
  }));
};
export default StyleSelector;
//# sourceMappingURL=StyleSelector.js.map